module.exports = "/_next/static/images/becomePartner-bf4ddf53b86f42f119d55377fe39a7aa.svg";